import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Join class names, with later Tailwind utilities beating earlier ones.
 *
 * Plain concatenation does not do that: `"px-4" + "px-2"` leaves both in the attribute and the
 * winner is whichever Tailwind emitted first, which is not something a caller can reason about.
 * Same helper, same name, as the sibling project this component set comes from.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
